export default __webpack_public_path__ + "static/media/divshot.212e2bfc.svg";